export default __webpack_public_path__ + "static/embossing-ed18de4d9679b820c1264918e002c31a.png";